import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LANDING_LINKS } from '@/config/landing-links';
import { SvgIcon } from '@/components/SvgIcon';

import footerStyles from '../../LandingFooter.module.sass';
import styles from './FooterSocials.module.sass';

export const FooterSocials = () => {
  const { t } = useTranslation();

  return (
    <nav className={styles.socials}>
      <div className={footerStyles.title}>
        {t('translation.landingFooter.socialNetworks')}
      </div>
      <ul className={styles.list}>
        <li>
          <Link
            to={LANDING_LINKS.TELEGRAM_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={styles.link}
          >
            <SvgIcon name="telegram-fill-circle" />
            <span>Telegram</span>
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.LINKEDIN_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={styles.link}
          >
            <SvgIcon name="linkedin-fill-circle" />
            <span>LinkedIn</span>
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.TWITTER_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={styles.link}
          >
            <SvgIcon name="x-fill-circle" />
            <span>X</span>
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.YOUTUBE_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={styles.link}
          >
            <SvgIcon name="youtube-fill-circle" />
            <span>YouTube</span>
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.MEDIUM_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={styles.link}
          >
            <SvgIcon name="medium-fill-circle" />
            <span>Medium</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
};
